import React from 'react';

const StepItem = ({ number, title, description }) => {
  return (
    <div className="flex flex-col sm:flex-row  sm:gap-[30px] mb-[28px] last:mb-0">
      <div
        className="mb-[10px] text-[38px] sm:text-[62px] text-[#F7F7F6] tracking-[-0.03em] leading-[110%] font-bold font-barlowCondensed"
      >
        {number}
      </div>
      <div>
        <h3
          className="mb-[3px] text-[14px] sm:text-[18px] text-[#F7F7F6] tracking-[-0.03em] leading-[110%] font-montserrat font-bold">
          {title}
        </h3>
        <p
          className="text-[12px] sm:text-[14px] text-[#F7F7F6] font-montserrat font-medium leading-4 tracking-[-0.02em] opacity-90">
          {description}
        </p>
      </div>
    </div>
  );
};

export default function HowItWorksSection() {
  const steps = [
    {
      number: '01',
      title: 'Sign up and get scanned',
      description:
        'Open a SaddleFit account and book a 3D scan where we are on the road—fast, repeatable, and built for serious fit work.'
    },
    {
      number: '02',
      title: 'Order your custom tree',
      description:
        'We translate your horse\'s scan into a tree spec so the form matches the back you measured—not an average mold.'
    },
    {
      number: '03',
      title: 'Pick your saddle maker',
      description:
        'Stay with your current maker or move to someone new. The tree is yours to place wherever the craft aligns with your goals.'
    },
    {
      number: '04',
      title: 'We ship; they build',
      description:
        'SaddleFit sends the tree straight to your maker so they can build the finished saddle on a foundation that already fits.'
    }
  ];

  return (
    <section
      id="how-it-works"
      className="relative py-12 md:py-24 bg-cover bg-center"
      style={{
        backgroundImage: `url('/images/how-it-works-bg.png')`,
        backgroundColor: '#1a1a1a'
      }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-[#0000007D]"></div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-20">
        <div className="flex flex-row gap-8 sm:gap-[62px] items-center">
          {/* Vertical Text */}
          <div className="flex-shrink-0">
            <div
              className="whitespace-nowrap origin-center font-barlowCondensed font-bold text-[#F7F7F6] text-[36px] sm:text-[60px] tracking-[-0.03em] leading-[110%]"
              style={{
                writingMode: 'vertical-rl',
                transform: 'rotate(180deg)',
              }}
            >
              HOW IT WORKS
            </div>
          </div>

          {/* Steps */}
          <div className="flex-1 max-w-xl">
            {steps.map((step, index) => (
              <StepItem
                key={index}
                number={step.number}
                title={step.title}
                description={step.description}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
